import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import PhotographyPage from './PhotographyPage';

const msp = (state, ownProps) => ({});

const mdp = (dispatch) => ({});

export default withRouter(connect(msp, mdp)(PhotographyPage));
